import { SignIn } from '@clerk/clerk-react';

export function SignInPage() {
    return (
        <div className="min-h-screen bg-white flex flex-col items-center justify-center px-4 py-12">
            <div className="w-full max-w-[28rem] flex flex-col items-center">
                <img
                    src="/logo.png"
                    alt="LANZ CTS"
                    className="h-16 w-auto mb-2"
                />
                <p className="text-xs text-gray-500 tracking-[0.25em] uppercase mb-8">
                    Dispatch
                </p>

               <SignIn
                    routing="virtual"
                    appearance={{
                        elements: {
                            rootBox: 'w-full flex justify-center',
                            card: 'shadow-lg border border-gray-200 rounded-xl',
                            logoBox: 'hidden',
                            headerTitle: 'hidden',
                            headerSubtitle: 'hidden',
                            footer: 'hidden',
                            formButtonPrimary: 'bg-black hover:bg-gray-800 text-white text-sm normal-case',
                            formFieldInput: 'border-gray-300 focus:border-black focus:ring-black',
                            formFieldLabel: 'text-xs text-gray-700 font-medium',
                        },
                    }}
                />

                <p className="mt-6 text-xs text-gray-500 text-center leading-relaxed">
                    Staff access only. Sign in with the email registered to your dispatcher account.
                </p>
            </div>
        </div>
    );
}
